import {
  getBlockAbove,
  getPluginType,
  getStartPoint,
  insertNodes,
  someNode,
  withoutNormalizing,
  ELEMENT_TABLE,
} from '@udecode/plate';
import { selectEditor } from '@udecode/plate-common';

import { getEmptyTableNode } from './utils/getEmptyTableNode';

/**
 * Insert table if selection not in table.
 * Select start of table.
 */
export const insertTable = (
  editor,
  { rowCount = 2, colCount = 2, header },
) => {
  withoutNormalizing(editor, () => {
    if (
      !someNode(editor, {
        match: { type: getPluginType(editor, ELEMENT_TABLE) },
      })
    ) {
      insertNodes(
        editor,
        getEmptyTableNode(editor, { header, rowCount, colCount }),
      );

      if (editor.selection) {
        const tableEntry = getBlockAbove(editor, {
          match: { type: getPluginType(editor, ELEMENT_TABLE) },
        });
        if (!tableEntry) return;

        selectEditor(editor, { at: getStartPoint(editor, tableEntry[1]) });
      }
    }
  });
};
